import { useState } from 'react';
import useBusinessPostApi from '~/lib/useBusinessPostApi.js';
import Modal from '~/components/Modal';
import { SparklesIcon } from '@heroicons/react/24/outline';
import * as Toast from '~/lib/Toast';

const AssistantFeedback = ({ backgroundTaskId }) => {
    const [showModal, setShowModal] = useState(false);
    const [feedbackText, setFeedbackText] = useState('');
    const { save: saveFeedback, isSaving } = useBusinessPostApi('/assistant/feedback');

    const handleCloseModal = () => {
        setShowModal(false);
        setFeedbackText('');
    };

    const handleSubmitText = () => {
        if (!feedbackText.trim()) {
            handleCloseModal();
            return;
        }

        saveFeedback({
            backgroundTaskId,
            isPositive: false,
            text: feedbackText,
        }).then(() => {
            handleCloseModal();
            Toast.success('Successfully sent feedback')
        }).catch(() => {
            Toast.error('Failed to save feedback, please try again');
        });
    };

    if (!backgroundTaskId) {
        return null;
    }

    return (
        <>
            <div className="justify-end sm:pr-16 flex items-center gap-2 mt-2 text-gray-500 text-sm">
                <button
                    type="button"
                    onClick={() => setShowModal((old) => !old)}
                    className="hover:text-gray-700 transition-colors flex items-center gap-x-2"
                >
                    <SparklesIcon className="w-4 h-4" />
                    Improve this answer
                </button>
            </div>

            {showModal && (
                <div
                >
                    <div className="space-y-2">
                        <div className="text-xl font-semibold text-gray-900">
                            Send feedback
                        </div>
                        <textarea
                            value={feedbackText}
                            onChange={(e) => setFeedbackText(e.target.value)}
                            placeholder="Let us know how we could have answered this better"
                            className="w-full h-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500 resize-none"
                            autoFocus
                        />
                        <div className="flex gap-x-2">
                            <button
                                type="button"
                                onClick={handleSubmitText}
                                className="btn-pill"
                                disabled={isSaving}
                            >
                                {isSaving ? 'Sending...' : 'Send'}
                            </button>
                            <button
                                type="button"
                                onClick={handleCloseModal}
                                className="btn-gray-pill"
                                disabled={isSaving}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AssistantFeedback;
